{
  "name": "oceanpress",
  "version": "1.0.14",
  "type": "module",
  "description": "从思源笔记本生成静态站点的工具",
  "author": "siyuan-note",
  "license": "MIT",
  "keywords": [
    "siyuan",
    "static-site-generator",
    "markdown",
    "blog",
    "ssg"
  ],
  "homepage": "https://github.com/siyuan-note/oceanpress#readme",
  "bugs": {
    "url": "https://github.com/siyuan-note/oceanpress/issues"
  },
  "scripts": {
    "dev": "vite",
    "cli": "tsx ./src/cli.ts",
    "cli-w": "tsx watch ./src/cli.ts",
    "build": "vite build && npm run build_lib",
    "build_lib": "vite build --config vite.sw.config.ts",
    "build_app": "vite build --mode library",
    "build_cli": "tsup",
    "build_plugin_ui": "vite build --config vite.plugin.config.ts",
    "dev_plugin_ui": "vite build --watch --config vite.plugin.config.ts",
    "preview": "vite preview"
  },
  "bin": {
    "oceanpress": "./dist-cli/cli.js"
  },
  "files": [
    "dist/assets",
    "dist/dev",
    "dist/index.html",
    "dist/ocean_press-log.png",
    "dist-app/assets",
    "dist-app/dev",
    "dist-app/app.*",
    "dist-cli",
    "*.md"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/siyuan-note/oceanpress.git"
  },
  "dependencies": {
    "@aws-sdk/client-s3": "^3.873.0",
    "@hono/node-server": "^1.19.0",
    "cheerio": "1.1.2",
    "commander": "^14.0.0",
    "effect": "^3.17.8",
    "fzstd": "^0.1.1",
    "hono": "^4.9.4",
    "jszip": "^3.10.1",
    "meilisearch": "^0.52.0",
    "naive-ui": "^2.42.0",
    "octokit": "^5.0.3",
    "superjson": "^2.2.2",
    "tsx": "^4.20.4",
    "turndown": "^7.2.2",
    "vditor": "^3.11.1",
    "vue": "^3.5.19",
    "vue-router": "^4.5.1",
    "zstd-codec": "^0.1.5"
  },
  "devDependencies": {
    "@types/turndown": "^5.0.6",
    "@vitejs/plugin-vue": "^6.0.1",
    "@vitejs/plugin-vue-jsx": "^5.0.1",
    "dependency-cruiser": "^17.0.1",
    "oceanpress-rpc": "workspace:*",
    "oceanpress-server": "workspace:*",
    "tsup": "^8.5.0",
    "typescript": "^5.9.2",
    "vite": "^7.1.3",
    "vite-plugin-vue-devtools": "^8.0.0",
    "vue-tsc": "^3.0.6"
  }
}
